import { ChevronUp, ChevronDown, Loader2 } from 'lucide-react';

interface LoadMoreButtonProps {
  direction: 'up' | 'down';
  isLoading: boolean;
  onClick: () => void;
}

export function LoadMoreButton({ direction, isLoading, onClick }: LoadMoreButtonProps) {
  return (
    <div className={`flex justify-center ${direction === 'up' ? 'mb-4' : 'mt-6 mb-4'}`}>
      <button
        onClick={onClick}
        disabled={isLoading}
        className="flex items-center gap-2 px-4 py-2 bg-white/[0.03] border border-white/10 rounded-full text-sm text-white/60 hover:text-white hover:border-white/20 transition-all disabled:opacity-50"
      >
        {isLoading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : direction === 'up' ? (
          <ChevronUp className="h-4 w-4" />
        ) : (
          <ChevronDown className="h-4 w-4" />
        )}
        <span>
          {direction === 'up'
            ? 'Charger les événements précédents'
            : 'Charger les événements suivants'}
        </span>
      </button>
    </div>
  );
}
